import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { getBaseUrl } from "frame";
import fromTypes from "../actions/types";

import { onSetPasswordFulfilled, onSetPasswordFailed } from "../actions";

const setPasswordEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromTypes.AUTHORISATION_SET_PASSWORD_REQUESTED),
		mergeMap(({ payload }) =>
			ajax({
				url: `${getBaseUrl()}/api/reset-password${payload}`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: {
					password: state$.value.authorisation.setPassword.password,
					confirmPassword:
						state$.value.authorisation.setPassword.confirmPassword,
				},
			})
				.pipe(
					mergeMap((ajaxResponse) => {
						const message =
							ajaxResponse.response ??
							ajaxResponse.xhr?.responseText?.replace(/^"|"$/g, "") ??
							"Password updated successfully.";
						return of(onSetPasswordFulfilled(message));
					}),
					catchError((error) =>
					of(onSetPasswordFailed(
						typeof error?.response === "string"
							? error.response
							: error?.message || "Set password failed. Please try again."
					))
				)
				)
		)
	);

export default setPasswordEffect;
